// Persisted pre-A3 view state may still name the old `ambient` placeholder.
// It is a migration token, never a domain aggregate id.
export const loadableConversationId = (
    conversationId: string | null,
): string | null =>
    conversationId === null || conversationId === "ambient"
        ? null
        : conversationId;
